import React from 'react';

import Banner from './Banner';
import Collaborate from './Collaborate';
import Features from './Features';
import WhatWeDo from './WhatWeDo';
import WhoWeAre from './WhoWeAre';
import WhyWork from './WhyWork';

const Home: React.FC = () => (
  <>
    <Banner />
    <WhoWeAre />
    <WhatWeDo />
    <Features />
    <WhyWork />
    <Collaborate />
  </>
);

export default Home;
